module.exports = __webpack_public_path__ + "img/beach_new.0a6fdf10.svg";